import { func, object, string } from 'prop-types';
import { useCallback, useEffect, useState } from 'react';

import Formsy from 'formsy-react';
import { isEmpty, mergeWith } from 'lodash';
import { FormBody, Button, FormCard, FormFooter } from 'twyne-new.ui';

import HeaderContainerGrid from '@/components/headerContainer/Grid';
import CustomFields from 'components/custom_fields/CustomFields';

export default function SettingsForm({ options, settings, onSubmit, settingKey, title }) {
  const [data, setData] = useState(null)
  const config = data?.[settingKey] || {}

  useEffect(() => {
    settings && settings.system_config && (settings.system_config.wildcard = null)
    setData({ ...settings })
  }, [settings])

  const handleCustomChange = useCallback((key, value) => {
    setData(mergeWith({}, data, {
      [settingKey]: {
        [key]: value || '',
      },
    }, (source, target) => {
      if (Array.isArray(source)) {
        return target;
      }
    }))
  }, [data, settingKey])

  const handleValidSubmit = useCallback(() => {
    onSubmit(data)
  }, [onSubmit, data])

  if (isEmpty(data) || !config || !options) {
    return null
  }

  return <Formsy onValidSubmit={handleValidSubmit}>
    <HeaderContainerGrid title={title} />
    <FormBody>
      <FormCard>
        <CustomFields
          config={options}
          onChange={handleCustomChange}
          custom={config}
          title={title}
        />
      </FormCard>
      <FormFooter className='mb-0!'>
        <Button type="submit" color="accent">Save</Button>
      </FormFooter>
    </FormBody>
  </Formsy>
}

SettingsForm.propTypes = {
  settings: object,
  onSubmit: func,
  options: object,
  config: object,
  title: string,
  settingKey: string,
};

SettingsForm.defaultProps = {};
